// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navbar {
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 9999;
  transition: transform 0.3s ease;
  padding: 0.8rem 10rem;
  background-color: #fff;
  border-bottom: 2px solid #327a6d;
}

.navbar .container-fluid img {
  width: 50px;
}

.navbar .container-fluid .navbar-txt-header {
  display: flex;
  flex-direction: column;
}

.container-fluid button {
  border: none;
}

.container-fluid .navbar-nav {
  gap: 2rem;
}

.nav-link {
  font-weight: 500;
}

.navbar-collapse {
  display: none;
  transition: display 0.3s ease;
}

.navbar-collapse.active {
  display: block;
}

.navbar-toggler {
  cursor: pointer;
}

.nav-link:hover {
  color: #327a6d;
}

@media (min-width: 600px) and (max-width: 1080px) {
  .navbar {
    padding: 0.8rem;
  }
  .navbar .container-fluid .navbar-collapse {
    padding: 1rem 0rem 0rem 0rem;
  }
  .container-fluid .navbar-collapse .navbar-nav {
    gap: 1rem;
  }
}

@media (max-width: 580px) {
  header .navbar {
    padding: 0.8rem;
  }

  header .navbar .container-fluid .navbar-txt-header {
    display: none;
  }

  .navbar .container-fluid .navbar-collapse {
    padding: 1rem 0rem 0rem 0rem;
  }
  .container-fluid .navbar-collapse .navbar-nav {
    gap: 1rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/navbar.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,WAAW;EACX,aAAa;EACb,+BAA+B;EAC/B,qBAAqB;EACrB,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,eAAe;EACjB;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,SAAS;EACX;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,4BAA4B;EAC9B;EACA;IACE,SAAS;EACX;AACF","sourcesContent":[".navbar {\r\n  position: fixed;\r\n  top: 0;\r\n  width: 100%;\r\n  z-index: 9999;\r\n  transition: transform 0.3s ease;\r\n  padding: 0.8rem 10rem;\r\n  background-color: #fff;\r\n  border-bottom: 2px solid #327a6d;\r\n}\r\n\r\n.navbar .container-fluid img {\r\n  width: 50px;\r\n}\r\n\r\n.navbar .container-fluid .navbar-txt-header {\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.container-fluid button {\r\n  border: none;\r\n}\r\n\r\n.container-fluid .navbar-nav {\r\n  gap: 2rem;\r\n}\r\n\r\n.nav-link {\r\n  font-weight: 500;\r\n}\r\n\r\n.navbar-collapse {\r\n  display: none;\r\n  transition: display 0.3s ease;\r\n}\r\n\r\n.navbar-collapse.active {\r\n  display: block;\r\n}\r\n\r\n.navbar-toggler {\r\n  cursor: pointer;\r\n}\r\n\r\n.nav-link:hover {\r\n  color: #327a6d;\r\n}\r\n\r\n@media (min-width: 600px) and (max-width: 1080px) {\r\n  .navbar {\r\n    padding: 0.8rem;\r\n  }\r\n  .navbar .container-fluid .navbar-collapse {\r\n    padding: 1rem 0rem 0rem 0rem;\r\n  }\r\n  .container-fluid .navbar-collapse .navbar-nav {\r\n    gap: 1rem;\r\n  }\r\n}\r\n\r\n@media (max-width: 580px) {\r\n  header .navbar {\r\n    padding: 0.8rem;\r\n  }\r\n\r\n  header .navbar .container-fluid .navbar-txt-header {\r\n    display: none;\r\n  }\r\n\r\n  .navbar .container-fluid .navbar-collapse {\r\n    padding: 1rem 0rem 0rem 0rem;\r\n  }\r\n  .container-fluid .navbar-collapse .navbar-nav {\r\n    gap: 1rem;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
